
import styles from'./Greeting.module.scss';
import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import common from '../../../common';


const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;


function Greeting() {

    const { pToast, useAlert, useModal, useConfirm, useLoading } = common();
    const { pAlert, AlertComponent } = useAlert();
    const { pModal, ModalComponent} = useModal();
    const { pConfirm, ConfirmComponent} = useConfirm();
    const { pLoadingOn, pLoadingOff, LoadingComponent } = useLoading();
    const [data, setData] = useState({});



    // const fetchData = async () => {
    //     try {
    //         pLoadingOn();
    //         const response = await axios.post(`${API_BASE_URL}/yehs_document/out/get_detail`, { type: "yehs_intro" , idx : 0 , headCate : 8 } , {
    //             withCredentials: true
    //         });

    //         if (response.data.result === 't') {
    //             const data = response.data.data;
    //             setData(data)
    //         } else {
    //             pAlert(response.data.msg);
    //         }
    //     } catch (error) {
    //         console.error('Data fetching failed:', error);
    //     } finally {
    //         pLoadingOff();
    //     }
    // }


    // useEffect(() => {
    //     fetchData();
    // }, []);




    return (
        <>
            <div className="components_wrap">
                <span className='components_wrap_title'>회장 인사말</span>
                {/* <div
                className='intro_wrap'
                dangerouslySetInnerHTML={{ __html: data.contents }}></div> */}

                <div className={styles.greeting_wrap}>
                    <div className={styles.greeting_sec_1}>
                        <div className={styles.greeting_1_left_box}>
                            {/* <img src="/img/2025ChairProfile.jpg" alt="2025회장" /> */}
                            {/* <img src="/img/2025ChairProfile.png" alt="2025회장" /> */}
                            <img src="/img/2026ChairProfile.png" alt="2026회장 이종원" />
                        </div>

                        {/* 우측 텍스트 영역 */}
                        <div className={styles.greeting_1_right_box}>
                            <div className={styles.greeting_title_box}>
                                <div className={styles.greeting_left_title}>
                                    “공학의 기틀 위 담대한 도전,
                                </div>
                                <div className={styles.greeting_right_title}>
                                    미래를 향한 오늘의 도약”
                                </div>
                            </div>
                            <h3>한국공학한림원 차세대공학리더 <span className={styles.bold_text}>제21대 회장 이종원</span></h3>
                            <ul>
                                <li>- 2021년 제255회 NAEK Forum 입회</li>
                                <li>- 2024년 기획3부 차장</li>
                                <li>- 2025년 대외사업부 부회장</li>
                            </ul>
                        </div>
                    </div>
                    <div className={styles.greeting_sec_2}>
                        <br/>
                        대한민국 공학의 미래를 이끌어갈 젊은 리더들이 모인 공동체, <span className={styles.bold_text}>한국공학한림원 차세대공학리더</span>를 찾아주신 여러분을 진심으로 환영합니다.
                        <br/><br/>
                        Young Engineers Honor Society(이하 YEHS)는 한국공학한림원 산하 단체로서, 각 대학 총장/학장의 추천을 받은 다양한 전공의 공학도들로 구성되어 전국적인 규모의 공대생 네트워크를 구축하며 공학의 가치를 나누기 위해 설립되었습니다. 공학을 통해 사회와 산업, 그리고 미래를 연결하는 젊은 인재들이 모여 서로의 지식과 경험을 나누고, 더 나은 세상을 만들어가기 위한 고민과 실천을 이어가고 있습니다.
                        <br/><br/>
                        대한민국 및 국제사회의 젊은 공학의 흐름을 선도하고자 하는 비전 아래 2004년 설립된 YEHS는, 2026년 현재까지 지속적인 성장과 발전을 이어오고 있습니다. 현재 전국 30여 개 대학 2,000여 명의 회원들이 활발한 학술교류와 사회공헌 활동을 통해 공학의 가치 확산과 의미 있는 연결을 만들어가고 있습니다. 
                        <br/><br/>
                        이제 YEHS는 단순한 교류를 넘어, 공학을 매개로 새로운 협력의 방식과 네트워크의 깊이를 확장해 나가고자 합니다. YEHS는 그간 축적해 온 학술적 전통과 조직적 기반을 바탕으로 한 단계 더 도약하는 젊은 공학인 커뮤니티로 성장하고자 합니다. 국내 활동을 넘어 해외 공학 단체들과의 교류를 적극적으로 확대하고, 공학뿐만 아니라 다양한 분야의 젊은 리더들과의 협력을 통해 보다 확장된 시야와 연결을 만들어가고자 합니다. 이를 통해 YEHS는 단순한 학술 네트워크를 넘어, 미래 사회를 이끌어갈 글로벌 공학 리더들의 플랫폼으로 자리매김하고자 합니다.
                        <br/><br/>
                        또한, 젊은 공학도들이 기술적 전문성을 넘어 사회적 책임과 리더십을 갖춘 인재로 성장할 수 있는 환경을 만들어가고 있습니다. 다양한 세미나와 포럼, 교류 프로그램을 통해 서로의 생각을 나누고, 공학이 사회에 미치는 영향과 역할에 대해 함께 고민하며, 미래를 설계하는 주체로 성장해 나가고 있습니다.
                        <br/><br/>
                        YEHS는 서로 다른 가능성이 모여 더 큰 방향을 만들어가는 연결의 장이며, 도전을 통해 스스로의 한계를 확장해 나가는 성장의 공간입니다. 이곳에서의 경험은 단순한 활동을 넘어, 각자가 앞으로 나아갈 길을 구체화하고 더 넓은 세상을 향해 나아가는 중요한 전환점이 될 것입니다.
                        <br/><br/>
                        앞으로도 YEHS는 공학을 기반으로 한 지식과 경험을 나누며, 다양한 분야와의 연결을 통해 새로운 가치를 창출하고자 합니다. 나아가 국내를 넘어 글로벌 무대에서 의미 있는 변화를 만들어가는 젊은 공학 리더들이 함께 성장하는 공동체로 자리해 나가겠습니다.
                        <br/><br/>
                        감사합니다.
                        <br/><br/>
                        <span className={styles.bold_text}>차세대공학리더 제21대 회장 이종원</span>
                    </div>
                    <div className={styles.greeting_sec_3}>
                        <span className='components_wrap_title'>설립목적</span>
                        · 다양한 배경을 지닌 공대생 사이의 교류를 활성화하여 다양한 이공계 분야를 아우르는 전국적인 공대생 네트워크를 구축한다.
                        <br/><br/>
                        · 차세대공학리더로서의 잠재력을 가진 이공계 학생들에게, 앞으로 훌륭한 리더로 성장하는 데 요구되는 능력과 소양을 갖출 수 있도록 다양한 기회를 제공한다.
                        <br/><br/>
                        · 공학적 배경을 가진 차세대 리더를 양성한다.
                    </div>
                    <div className={styles.greeting_sec_4}>
                        <span className='components_wrap_title'>비전</span>
                        <div className={styles.greeting_4_title_box}>
                        다양한 산업, 학계, 정책 분야에서의 역량과 리더십을 갖추고, 이를 바탕으로 국가 및 국제사회에 
                        기여하는 <span className={styles.blue_text}>차세대 글로벌 과학기술 도전자(Global Engineering Leaders) 단체</span>
                        </div>

                        <div className={styles.greeting_4_bottom}>
                            <div className={styles.greeting_4_left_box}>
                                <img src="/img/greeting_vision.jpg" alt="greeting_vision" />
                            </div>
                            <div className={styles.greeting_4_right_box}>
                                · 우리는 과학기술과 관련된 다양한 산업, 학계, 정책 분야에서 장차 대한민국의 미래를 짊어질 차세대 과학 기술지도자를 양성한다.
                                <br/><br/>
                                · 이를 위해 우리는 공학도로서 각 분야에 탁월한 공학적 능력을 기르고, 다양한 분야에 대한 지식과 경험을 학습하고 공유한다.
                                <br/><br/>
                                · 우리는 개개인의 역량을 개발하는 것에서 멈추지 않고, 도덕적 리더십을 갖추고 사회에 기여하기 위한 노력을 게을리하지 않는다.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Greeting;